<template>
  <div>
    <h1>アクセス</h1>
    <h2>学内マップ</h2>
    <div><img src="access.png" style="width: 100%;"></div>
    <h2>研究室の割り当て</h2>
    <h3>教員研究室</h3>
    <div>総合研究棟2号館106号室: 福士 将</div>
    <div>総合研究棟2号館103号室: 黒川 陽太</div>
    <h3>学生研究室</h3>
    <div>総合研究棟2号館107号室</div>
    <div>総合研究棟2号館108号室</div>
    <h3>ゼミ室</h3>
    <div>総合研究棟2号館109号室</div>

  </div>
</template>

<script>
export default {
  name: 'WorkView',
  props: {
    msg: String
  }
}
</script>


<style scoped>

</style>
